import React from "react";
import { chapters } from "../data/landing";
export function ContentsSection() {
  return <section id="contenido" className="scroll-mt-20 border-b border-line" data-id="element-35" data-mp="30ie77hu83n78">
      <div className="mx-auto grid max-w-6xl gap-12 px-6 py-20 md:py-28 lg:grid-cols-[1fr_1.4fr] lg:gap-20" data-id="element-36" data-mp="34khlsfc6v7wq">
        <div className="lg:sticky lg:top-28 lg:self-start" data-id="element-37" data-mp="39jc2nbqlime7">
          <h2 className="font-serif text-4xl leading-tight text-cream md:text-5xl" data-id="element-38" data-mp="39isv8oykngef">
            Qué vas a encontrar dentro
          </h2>
          <p className="mt-6 leading-relaxed text-muted" data-id="element-39" data-mp="2gun9byvs7ld0">
            El objetivo no es que termines el ebook sintiéndote motivado por unas horas. Es que
            empieces a pensar, decidir y actuar desde una versión más serena, fuerte y abundante
            de vos mismo.
          </p>
        </div>

        <ol className="border-t border-line" data-id="element-40" data-mp="1t5lzq8b7q465">
          {chapters.map((chapter, index) => <li key={chapter} className="flex gap-6 border-b border-line py-6" data-id="element-41" data-mp="1y45lo8pt3fyi" data-mpi={index}>
              <span className="w-8 flex-none font-serif text-xl text-gold" aria-hidden="true" data-id="element-42" data-mp="1y22kqtn482f0">
                {String(index + 1).padStart(2, "0")}
              </span>
              <span className="text-lg leading-relaxed text-cream" data-id="element-43" data-mp="1kbzbd616y4ri">{chapter}</span>
            </li>)}
        </ol>
      </div>
    </section>;
}